import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { Box, Modal, ModalContext, Text } from 'dash-ui';
import {
  CurrentBrokerHasPortfoliosDocument,
  GetAllPortfolioFoldersDocument,
  GetPortfoliosDocument,
  GetPortfoliosTreeDocument,
  useDeletePortfolioByIdMutation,
} from 'gql/generated.graphql';

const RemoveFolderFromPortfolio = () => {
  const theme = useTheme();
  const { t } = useTranslation(['common']);
  const { isOpenCurrent, toggleModal, setPayload, payload } =
    useContext(ModalContext);
  const isOpen = !!isOpenCurrent['RemoveFolderFromPortfolio'];

  const [deleteProperty, { loading }] = useDeletePortfolioByIdMutation({
    refetchQueries: [
      GetPortfoliosDocument,
      CurrentBrokerHasPortfoliosDocument,
      GetAllPortfolioFoldersDocument,
    ],
  });

  const onModalClose = () => {
    toggleModal(false, 'RemoveFolderFromPortfolio');
    setPayload(null);
  };

  const onSubmitModal = () => {
    deleteProperty({
      variables: {
        portfolioId: payload.folderId,
      },
      refetchQueries: [
        {
          query: GetPortfoliosTreeDocument,
          fetchPolicy: 'network-only',
        },
        {
          query: GetAllPortfolioFoldersDocument,
          fetchPolicy: 'network-only',
        },
      ],
      onCompleted: () => {
        onModalClose();
        if (payload.onConfirm) {
          payload.onConfirm();
        }
      },
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onModalClose}
      title={
        t('pages:portfoliosPage:removeFolderFromPortfolioModal:header') || ''
      }
      cancelButton={{ title: t('common:labels.cancel'), onClick: onModalClose }}
      submitButton={{
        title: t('common:labels.delete'),
        isLoading: loading,
        disabled: loading,
        onClick: onSubmitModal,
      }}
    >
      <Box py={3}>
        <Text color={theme.colors.n80}>
          {t('pages:portfoliosPage:removeFolderFromPortfolioModal:subheader')}
        </Text>
      </Box>
    </Modal>
  );
};

export default RemoveFolderFromPortfolio;
